export var SubscriberPackageValue;
(function (SubscriberPackageValue) {
    SubscriberPackageValue["VALUE_0"] = "0";
    SubscriberPackageValue["VALUE_6"] = "6";
    SubscriberPackageValue["VALUE_14"] = "14";
    SubscriberPackageValue["VALUE_15"] = "15";
    SubscriberPackageValue["VALUE_17"] = "17";
    SubscriberPackageValue["VALUE_18"] = "18";
    SubscriberPackageValue["VALUE_22"] = "22";
    SubscriberPackageValue["VALUE_23"] = "23";
    SubscriberPackageValue["VALUE_24"] = "24";
    SubscriberPackageValue["VALUE_25"] = "25";
    SubscriberPackageValue["EMPTY"] = "";
})(SubscriberPackageValue || (SubscriberPackageValue = {}));
